module.exports = __webpack_public_path__ + "assets/img/09.03232b8c.png";